  <!-- mainPage is not used  -->
<template>
 <!-- <ion-app class='ionApp'> -->
     <!-- mainPage is not used  -->
   <ion-content  padding class="bc">
        <ion-header>
           ERAU Live ADS-B 0.0.6
            <!-- <ion-toolbar>
                <ion-title>ERAU Live ADS-B</ion-title>
            </ion-toolbar> -->
        </ion-header>

        <ion-grid style="height: 100%">
          <!-- <ion-row justify-content-center align-items-center style="height: 100%; flex-direction: column"> -->
             <!-- <ion-spinner name="ios"></ion-spinner> -->
             <!-- <ion-button size="default"  -->
                <!-- @click="clickHandler" color="primary"> -->
                <!-- <ion-icon ios="ios-map" md="md-map"></ion-icon> -->
                <!-- ERAU Login -->
            <!-- </ion-button> -->
            <!-- <ion-button size="default"  -->
                <!-- @click="clickHandler2" color="secondary"> -->
                <!-- <ion-icon ios="ios-map" md="md-map"></ion-icon> -->
                <!-- Guest Login -->
            <!-- </ion-button> -->

        <!-- </ion-row> -->
      </ion-grid>
     
       
    </ion-content> 
       
            
  <!-- /</ion-app> -->
 
   
</template>
<script scoped>
/// mainPage is not used 
    import {DeviceEventBus} from '../DeviceEventBus.js'
    const uuidv4 = require('uuid/v4');


export default {
    name:"mainPage",
    data(){
        return {
            test:null,
            timeout: { type: Number, default: 20000 },
            conCounter:0,
            isConnectedTimer:null,
            loadingController:null
        }
    },
    mounted(){
        this.id = uuidv4()
            console.log('mainPage mounted ',this.id )
            // console.log("Calling connection.connect")
            // this.$store.dispatch('connection/connect',{})
            
           /// mainPage is not used 
        this.isConnectedTimer= setInterval (this.handleConnection,2000)

           
    },
    methods:{
       async handleConnection(){
            console.log("mainPage/handleConnection")
            if(this.$store.state.connection.connected){
                    this.$router.push('/home');
                    clearInterval(this.isConnectedTimer)
                    if(this.loadingController) this.loadingController.dismiss()
            }else{
                console.log("waiting for network connection ",this.conCounter)
                
                if(this.conCounter==0){
                     let inThis = this
                        console.log("dispaying loadingController ",this.conCounter,this.$store.state.connection.connected)

                        this.loadingController = await this.$ionic.loadingController.create(
                            {message: 'Trying to Connect',spinner:"dots"}
                            )
                        this.loadingController.present()
        
                }
                this.conCounter = this.conCounter+1
           
            }

           
        },
        clickHandler(){
            console.log("clickHandler")
            //  this.$router.push('/home');
            this.$router.push('/erauLog');
        },
        clickHandler2(){
            console.log("clickHandler")
            this.$router.push('/home');
            
            //  this.$router.push('/erauLog');
        }
    }
}
</script>
<style scoped>
/* .bc {
    --background: url('../assets/flightline3.jpg') no-repeat center/cover fixed;
} */

ion-content{
     --background:none;
    background: url('../assets/flightline2.jpg') ;
    background-size: cover;
    background-position: center center;
    /* -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover; */
}
.ionApp{
   --background-color:red
}



/* @media screen and (orientation: portrait) { 
  ion-content {
    background: url('../assets/flightline2.jpg') ;
   }
}


@media screen and (orientation: landscape) {
    ion-content {
    background: url('../assets/flightline3.jpg') ;
   }
 } */
</style>
